import _replace from 'lodash/replace';

/*
  Inputs cause time consuming and unnecessary problems. In particular when trying to set a maxLength on a number input type.
  Accessing the event.keyCode value is also now deprecated https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode.
  This .js fle is for any useful time-saving methods for inputs.
*/

// This function allows the decimal point to keep consistent with html number type inputs.
export const restrictToNumber = value => _replace(value, /[^\d.]/g, '');

// This variation of the above function removes the decimal point also.
export const restrictToNumberOnly = value => _replace(value, /[^\d]/g, '');

export const validateHeightFormat = height => /^\d{1,3}(\.\d{1,3})?\s?((cm)|(m(\s?\d{1,2}\s?cm)?)|(ft(\s?\d{1,2}\s?in)?)|('(\s?\d{1,2}\s?")?))$/.test(height);

export const validateWeightFormat = weight => /^\d{1,3}(\.\d{1,3})?\s?((kg(s)?)|(lb(s)?)|(st(\s?\d{1,2}(\.\d{1,2})?\s?((lb)|(lbs)))?))$/.test(weight);
